/**
 * è½¬ç ç¶æ
 */
export enum TransState {
  /**
   * è½¬ç å¤±è´¥
   */
  FAIL = <any>'FAIL',
  /**
   * è½¬ç æå
   */
  SUCCESS = <any>'SUCCESS',
  /**
   * è½¬ç ç­å¾
   */
  WAITING = <any>'WAITING'
}
